import React from 'react'
import "./Header.css"

const Header=() =>{
  return (
    <div className='logo'>
    <img className='logo' alt='logo' src='Pokemon_logo.png'/>
    </div>
  )
}

export default Header;